import './ProgressBar.css'

interface Props {
  width: string;
}

const ProgressBar: React.FC<Props> = (props) => {
  return (
    <div className="progress-bar">
      <div style={{ width: props.width }}></div>
    </div>
  );
};

export default ProgressBar;